import { useEffect, useRef } from 'react';
import type { SetURLSearchParams } from 'react-router-dom';

const OPEN_PARAM = 'open';
const POINTS_OPEN_VALUE = 'points';

const IGNORED_PAYMENT_PARAMS = [
  'product',
  'product_id',
  'productId',
  'amount',
  'amount_cent',
  'amountCent',
  'points',
  'price',
  'price_cent',
  'payment',
  'method',
  'method_id',
  'payment_method',
  'payment_method_id',
  'paymentMethod',
  'paymentMethodId',
  'pay_method',
  'pay_method_id',
  'payModeId',
  'order',
  'order_id',
  'orderId',
  'order_no',
  'orderNo',
  'payment_order_id',
  'paymentOrderId',
  'redirect',
  'redirect_uri',
  'return_url',
  'returnUrl',
  'execution',
  'execution_id',
  'executionId',
];

export interface ExternalPointsLaunchOptions {
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
  onLaunch: () => void;
}

export function isExternalPointsLaunch(searchParams: URLSearchParams): boolean {
  const openValues = searchParams.getAll(OPEN_PARAM);
  return openValues.length === 1 && openValues[0] === POINTS_OPEN_VALUE;
}

export function cleanExternalPointsLaunchParams(searchParams: URLSearchParams): URLSearchParams {
  const nextParams = new URLSearchParams(searchParams);
  nextParams.delete(OPEN_PARAM);
  IGNORED_PAYMENT_PARAMS.forEach((param) => nextParams.delete(param));
  return nextParams;
}

export function useExternalPointsLaunch({
  searchParams,
  setSearchParams,
  onLaunch,
}: ExternalPointsLaunchOptions): void {
  const consumedSearchRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isExternalPointsLaunch(searchParams)) {
      consumedSearchRef.current = null;
      return;
    }

    const currentSearch = searchParams.toString();
    if (consumedSearchRef.current === currentSearch) return;
    consumedSearchRef.current = currentSearch;

    setSearchParams(cleanExternalPointsLaunchParams(searchParams), { replace: true });
    onLaunch();
  }, [onLaunch, searchParams, setSearchParams]);
}
